import { faPalette } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import DataTableToolbarButton from '../../../../voxel/DataTableToolbar/DataTableToolbarButton';
import { KeywordTableState } from '../logic/useKeywordTableState';

export interface RankColorButtonProps {
  tableState: KeywordTableState;
}

export const RankColorButton: React.FC<RankColorButtonProps> = ({ tableState }) => {

  if (!tableState.tableUIState.enableColor) return null;
  return (
    <DataTableToolbarButton
      tooltip="Toggle domain position color"
      toggle={tableState.tableUIState.colorRanks}
      iconProp={faPalette}
      disabled={!tableState.columnPickerBag.shownDomains.length}
      onClick={() =>
        tableState.setTableUIState((prev) => ({
          ...prev,
          colorRanks: !prev.colorRanks,
        }))
      }
    />
  );
};

export default RankColorButton;
